export default __webpack_public_path__ + "static/Sie Djohan-6a106808df60db956a9ae82e1ffd3388.webp";